import React, { Component } from 'react';
import connect from 'react-redux/es/connect/connect';
import { isMobile } from "react-device-detect";
import './styles/videoroom.css';
import '../global.css';
import Sidebar from '../../components/sidebar/sideBar';
import SectionHeader from '../../components/sectionHeader/sectionHeader';
import CallHistory from '../../components/callHistory/callHistory';
import VideoApp from './videoCall/videoApp';
import * as AuthUtils from '../../utils/auth';
import ParentLogin from '../parentLogin/parentLogin';
import * as TherapistActions from '../../actions/therapist';
import * as PatientActions from '../../actions/patient';
import * as MessageActions from '../../actions/messages';
import {addData} from '../../state/useFirebaseAuth/useFirebaseAuth';

import Loader from '../../components/Loader/loader';
import { LocalAudioTrack } from 'twilio-video';
import moment from 'moment';
import { fetchMoreChats, getChannelList, listMessage, fetchMoreMesssages, getChannels } from '../../utils/sendbird/sendbirdUtils';
import * as SendbirdUtils from '../../utils/sendbird/sendbirdUtils';
import { convertBlobToBase64 } from '../../utils/sendbird/sendbirdSchema';
import ScheduledSupervisionModal from '../../components/scheduled-supervision-modal/scheduled-supervision-modal';
import { getUserAccess, logError, sendSupervisionAction } from '../../apis/custom';


class VideoRoom extends Component {
	constructor(props) {
		super(props);
		this.state = {
			fullScreen : false,
			showSidebar: false,
			notifyMenu: false,
			muteAll: false,
			showSupervisionModal:false,
			superVisionData: null,
			supervisionTime: []
		}
		this.endCall = this.endCall.bind(this);
		this.toggleFullScreen = this.toggleFullScreen.bind(this);
		this.toggleSidebar = this.toggleSidebar.bind(this);
	}

	componentDidMount(){
		const { match } = this.props;
		const { params } = match;

		if(AuthUtils.isAuthCookiePresent()){
			const callId = window.localStorage.getItem("therapistCallId");
			const { dispatch } = this.props;
			dispatch(TherapistActions.getCurrentUserConfirmation({roomId: params.therapistRoom}));
			dispatch(TherapistActions.getUserDetails());
			dispatch(TherapistActions.getActiveCallHistory());
			dispatch(TherapistActions.getGroupCallHistory());
			dispatch(TherapistActions.getPatientVisits());
			dispatch(TherapistActions.getUserStatus({roomId: params.therapistRoom}));
			//dispatch(PatientActions.getParticipants(params.therapistRoom));
			//this.fetchSendBirdData(callId)
			//fetchMoreChats(dispatch)
			let savedSuperVisionList = JSON.parse(window.localStorage.getItem('superVision'))

			if(savedSuperVisionList && savedSuperVisionList.length){
				for(let i in savedSuperVisionList){
					if(!savedSuperVisionList[i].date || (savedSuperVisionList[i].date &&  moment(savedSuperVisionList[i].date).format("MM/DD/YYYY") != moment().format("MM/DD/YYYY"))){
						savedSuperVisionList.splice(i, 1)
					}
				}
				window.localStorage.setItem('superVision', JSON.stringify(savedSuperVisionList))
			}



			if(callId){
				dispatch(TherapistActions.getCurrentActiveCallDetails({callId}));
			}

		}

		// this.fetchCOuntry( )
	}

	fetchCOuntry = async () => {
		// let timedifference = new Date().getTimezoneOffset();
		// console.log(Intl.DateTimeFormat().resolvedOptions().timeZone)
		// console.log(moment.tz.guess())
		// console.log(moment())
		// fetch('https://api.ipregistry.co/?key=tryout')
		// 	.then(function (response) {
		// 		return response.json();
		// 	})
		// 	.then(function (payload) {
		// 		console.log(payload.location.country.name + ', ' + payload.location.city);
		// 	});
	}

	fetchSendBirdData = async (callId) => {
		const { dispatch } = this.props;
		let userId = callId || localStorage.getItem('user')

		if (userId) {
			let res = await getUserAccess(userId)
			dispatch(MessageActions.setUserAccess(res.userAccess))
			await SendbirdUtils.connectUser({mobileNumber: userId}, dispatch);
			//fetchMoreChats(dispatch)
			//getChannelList(null, dispatch)
		}
	}

	toggleFullScreen(){
		this.setState(prevState =>({
			fullScreen : !prevState.fullScreen
		}))
	}

	toggleSidebar(){
		this.setState(prevState =>({
			showSidebar : !prevState.showSidebar,
			notifyMenu: false
		}))
	}

	endCall(){

		const { therapists, dispatch } =this.props;
		const callId = window.localStorage.getItem("therapistCallId");
		const { activeCallHistory } = therapists;
		const status = "End Call";
		
		dispatch(TherapistActions.changeCallStatus({callId, status}));
		
		activeCallHistory.forEach(activeCall => {
			if(activeCall.callStatus.toLowerCase() === "on call"){
				dispatch(TherapistActions.changeCallStatus({callId : activeCall.callId, status}));
			}
		});
		// window.localStorage.removeItem("therapistCallId");
		// window.sessionStorage.removeItem("twilioTherapistToken");
		// window.sessionStorage.setItem('therapistConnecting', "no");
		// dispatch(TherapistActions.getGroupCallHistory());
		// dispatch(TherapistActions.updateCallTimeStatus({"status":"end"}, () => {
		// 	window.location.reload();
		// }));
		
	} 

	muteUnmuteParticipant = (callId, isMute, participant, activeCalls) => {

		let id = []
		let callParticipant = activeCalls.find((activeCall) => {
			if (participant.identity.indexOf(activeCall.mobileNumber) !== -1) {
			  id = [activeCall.mobileNumber]
			}
			let patientName = activeCall.patient.split(" ")[0] + (activeCall.patient.split(" ")[1] ? activeCall.patient.split(" ")[1] : "");
			if (participant.identity.indexOf(patientName) !== -1) {
				id = [activeCall.mobileNumber]
			}
			
		  })
		  if(!id || id == ''){
			  id = participant.identity
		  }
		 		
		  if(id.length){
			let {room, match} = this.props
			if (room.activeRoom && room.activeRoom.localParticipant && room.activeRoom.localParticipant.dataTracks) {
				let JSOnstring = {
					participantIds: (Array.isArray(id)) ? id : [id],
					mute : isMute,
					updateTime: moment().unix().toString()
				}

				addData('participantsAudioStatus', 'videoroomcall-' + match.params.therapistRoom, JSOnstring)
			}
		}		  
	}

	muteUnmuteAllParticipants = (ids, isEnabled) => {

		let {room, match} = this.props
		if (room.activeRoom && room.activeRoom.localParticipant && room.activeRoom.localParticipant.dataTracks) {
			let JSOnstring = {
				participantIds: (Array.isArray(ids)) ? ids : [ids],
				mute : isEnabled,
				updateTime: moment().unix().toString()
			}

			//const fullMessage = JSON.stringify(JSOnstring);

			addData('participantsAudioStatus', 'videoroomcall-' + match.params.therapistRoom, JSOnstring)

			// if (localDataTrackPublication && localDataTrackPublication.track) {
			// 	localDataTrackPublication.track.send(fullMessage);
			// }
		}
		
		return
		
		const { therapists, dispatch } = this.props;
		const { activeCallHistory } = therapists;
		activeCallHistory.forEach(activeCall => {
			if(activeCall.callStatus.toLowerCase() === "on call"){
				dispatch(TherapistActions.changeCallField({callId : activeCall.callId, isMute : isEnabled}));
			}
		});
	}

	componentDidUpdate(prevProps){
		const { therapists, dispatch, match, messages, setting } = this.props;
		const { supervisionTime, showSupervisionModal } = this.state
		const { activeCallHistory, activeCallHistoryStatus } = therapists;
		const {messageList, chatList, userAccess} = messages
		const { params } = match;
		const callId = window.localStorage.getItem("therapistCallId");

		let activeCallFlag = false;
		//dispatch(PatientActions.getParticipants(params.therapistRoom));
		if(activeCallHistory && activeCallHistoryStatus === "new" && activeCallHistory.length > 0 && !callId ){
			dispatch(TherapistActions.unsetActiveCallHistoryFlag());
			activeCallHistory.forEach(activeCall => {
				if(activeCall.callStatus.toLowerCase() === "on call" && activeCall.source ==="web"){
					activeCallFlag = true;
					window.localStorage.setItem("therapistCallId", activeCall.callId);
					dispatch(TherapistActions.getCurrentActiveCallDetails({callId : activeCall.callId}));
				}
			});
			if(!activeCallFlag && window.localStorage.getItem("therapistCallId")){
				window.localStorage.removeItem("therapistCallId");
				window.sessionStorage.removeItem("twilioTherapistToken");
				window.sessionStorage.setItem('therapistConnecting', "no");
				dispatch(TherapistActions.getGroupCallHistory());
				dispatch(TherapistActions.updateCallTimeStatus({"status":"end"}, () => {
					setTimeout(function(){window.location.reload(); }, 2000);
				}));
			}
		}
		if(activeCallHistory && activeCallHistoryStatus === "new" && activeCallHistory.length === 0 && callId){
			dispatch(TherapistActions.unsetActiveCallHistoryFlag());
			window.localStorage.removeItem("therapistCallId");
			window.sessionStorage.removeItem("twilioTherapistToken");
            window.sessionStorage.setItem('therapistConnecting', "no");
			dispatch(TherapistActions.updateCallTimeStatus({"status":"end"}, () => {
				setTimeout(function(){window.location.reload(); }, 2000);
			}));
			dispatch(TherapistActions.getGroupCallHistory());
		}
		if(activeCallHistory && activeCallHistoryStatus === "new" && activeCallHistory.length !== prevProps.therapists.activeCallHistory.length){
			this.setState({
				notifyMenu: true
			});
		}

		if(setting && setting.currentUser != prevProps.setting.currentUser){
			this.fetchSendBirdData(setting.currentUser.mobileNumber)
		}


		if(chatList.length != prevProps.messages.chatList.length){
			let searchValue = 0
			let foundBcba = 0
			let selectedChat = null
			for(let i of chatList){			
				
				if(i.customType && i.customType == 'bcba_workday_summary' ){
					foundBcba = 1
					if(moment(i.createdAt).format("MM/DD/YYYY") == moment().format("MM/DD/YYYY")){
						selectedChat = i
						searchValue = 1
						break
					}
 				}

			}
			
 			//fetchMoreChats(dispatch)
			

			if(foundBcba == 1 && searchValue == 1) {
				fetchMoreMesssages(selectedChat, dispatch)
			}
			if(foundBcba == 1 && searchValue == 0){ 
			}
			 if(foundBcba == 0){ 
				fetchMoreChats(dispatch)
			}
		}

		// step number less than 2
		let patientVisitList = []

		if(messageList.length != prevProps.messages.messageList.length){
			for(let i of messageList){
				const {messageBody, type} = i
				if(type.toLowerCase() == 'form'){
					const {payload} = messageBody
					if(payload && payload.form && payload.form.formId && payload.form.formId == '142' && payload.form.step < 2){

						const { content } = payload.form
						if(content['142.50'] && content['142.57']){
							patientVisitList.push({...content, createdAt : i.createdAt})							
						}
					}
				}
				
			}
			//listMessage(messageList[0].url)
		}
		// patientVisitList.sort(function (a, b) {
		// 	return moment(a.createdAt).format('X') - moment(b.createdAt).format('X')
		// });

		if(patientVisitList.length){
			let supervisionData = []
			for(let visit of patientVisitList){
				if(visit['142.57'] && visit['142.57'].data && visit['142.57'].data[0] && visit['142.57'].data[0].topic && visit['142.57'].data[0].rows && visit['142.57'].data[0].rows[0] && visit['142.57'].data[0].topic.name && visit['142.57'].data[0].rows[0].name){
					
					

					
					// moment
					// let diff = moment(startTime).diff(moment())
					// let d = moment.duration(diff)
	
					// if (d.asMilliseconds() > -300000 && d.asMilliseconds() < 300000) {

					
					// 	this.setState({supervisionData, showSupervisionModal: true})
					// }


					supervisionData.push({
						...visit['142.50'].data,
						topic: visit['142.57'].data[0].topic.name,
						startTime: visit['142.57'].data[0].rows[0].name,
						endTime: (visit && visit['142.53'] && visit['142.53'].data) ? visit['142.53'].data.time : ""
					})


					// let savedSuperVision = JSON.parse(window.localStorage.getItem('superVision'))

					// console.log(supervisionData)

					// if (!savedSuperVision || (savedSuperVision.mobileNumber != supervisionData.mobileNumber && savedSuperVision.startTime != supervisionData.startTime)) {
					// 	if (currentTime >= startTime && currentTime < endTime) {
					// 		this.setState({ supervisionData, showSupervisionModal: true })
					// 	}
					// }
				}
			}
			let savedSuperVision = JSON.parse(window.localStorage.getItem('superVision'))

			let supervisionTime = []
			for(let i of supervisionData){

				//if(!(savedSuperVision.find(j => (j.mobileNumber == i.mobileNumber && i.startTime == j.startTime)))){
					supervisionTime.push(i)
				//}
			}
			this.setState({ supervisionTime })
		}

		if(supervisionTime.length){
			let savedSuperVision = window.localStorage.getItem('superVision')? JSON.parse(window.localStorage.getItem('superVision')) : [];
			if(!savedSuperVision || !(Array.isArray(savedSuperVision))) savedSuperVision = []
			
			if(Array.isArray(savedSuperVision)){
				for (let supervision of supervisionTime) {
					if (!(savedSuperVision && savedSuperVision.find(j => (j.mobileNumber == supervision.mobileNumber && supervision.startTime == j.startTime))) && supervision.topic.toLowerCase() != 'in person' && showSupervisionModal == false && (userAccess && userAccess.includes('BCBA'))) {
						let currentTime = moment()
						let startTime = moment(moment().format("MM/DD/YYYY") + " " + supervision.startTime)
						let endTime = moment(moment().format("MM/DD/YYYY") + " " + supervision.endTime)
						// let startTime = moment(moment(visit.createdAt).format("MM/DD/YYYY") +  " " + supervisionData.startTime)
						//let endTime = moment(moment(visit.createdAt).format("MM/DD/YYYY") +  supervisionData.endTime)
					
						if (currentTime >= startTime && currentTime < endTime) {
							savedSuperVision.push({
								mobileNumber: supervision.mobileNumber,
								startTime: supervision.startTime,
								date: moment().format("MM/DD/YYYY")
							})

							//window.localStorage.setItem('superVision', JSON.stringify(savedSuperVision))
							setTimeout(() => {
								this.setState({ selectedSupervision: supervision, showSupervisionModal: true, savedSuperVision })
							}, 500);
						}
					}
				}
			}
		}
	}

	closeSupervisionModal = async (val) => {
		let supervisionData = this.state.selectedSupervision
		let savedSuperVision = this.state.savedSuperVision

		try {
			let savedSuperVisionList = JSON.parse(window.localStorage.getItem('superVision')) || []
			savedSuperVisionList = [...savedSuperVision, ...savedSuperVisionList]
			window.localStorage.setItem('superVision', JSON.stringify(savedSuperVisionList))


			let data = {
				"type": "video_room",
				"platform": "web",
				"dateTime": moment().format("DD/MM/YYYY hh:mm A"),
				"deviceLocation": Intl.DateTimeFormat().resolvedOptions().timeZone,
				"userName": supervisionData.firstName + " " + supervisionData.lastName,
				"clickOn": val == 1 ? 'Join R/BTVideo Room' : 'Dismiss'
			}
			let response = await sendSupervisionAction(data)

			this.setState({
				showSupervisionModal: false,
				selectedSupervision: null,
				savedSuperVision: null
			});

			if (val == 1) {
				window.location.assign(`/videoRoom/${supervisionData.videoRoom}`);
			}
		} catch (e) {

			await logError({
				error : JSON.stringify(e), 
				errorMessage: 'video Room on modal click error', 
				type: "frontend", 
				time: moment().format("YYYY-MM-DD HH:mm"),
				token: AuthUtils.getAuthCookie(),
				currentUrl: window.location.href
			})
		}
		

		
	}

	render() {
		const { setting, match } = this.props;
		const callId = window.localStorage.getItem("therapistCallId");
		if(!AuthUtils.isAuthCookiePresent() || (AuthUtils.isAuthCookiePresent() && !setting.currentUserConfirmation)){
			return <ParentLogin {...this.props}/>
		}
		if(!setting.currentUser){
			return <Loader />;
		}
		
		let showSidebar = true;
		let showVideoApp = true;

		if(this.state.fullScreen){
			showSidebar = false;
		}
		if(isMobile){
			if(this.state.showSidebar){
				showVideoApp = false;
			}else{
				showSidebar = false;
			}
		}
		
		return (
			// <div className="main-room-container fullscreen-container"></div>
			<div className={"main-room-container" + (this.state.fullScreen ? " fullscreen-container" : "")}>
			{showSidebar && <Sidebar openSidebar={showSidebar} closeSidebar={this.toggleSidebar} /> }
				{this.state.showSupervisionModal && <ScheduledSupervisionModal visible={this.state.showSupervisionModal} supervisionData={this.state.selectedSupervision}
					onCancel={this.closeSupervisionModal} dismissSupervisionModal={this.closeSupervisionModal} />}
			<section className="page-content">
			   { callId  ? <VideoApp {...this.props} {...this.state} 
									   endCall={this.endCall} 
									   muteUnmuteAllParticipants={this.muteUnmuteAllParticipants}
									   muteUnmuteParticipant={this.muteUnmuteParticipant}
									   toggleSidebar={this.toggleSidebar}
									   toggleFullScreen={this.toggleFullScreen}/> :
				 [<SectionHeader therapistRoom={match.params.therapistRoom} key="1"/>,
				<CallHistory key="2" />]}
			</section>
            </div>
		  ) 
	}
}

function mapStateToProps(state) {
	return state;
}

export default connect(mapStateToProps)(VideoRoom);

